export async function getRoles(){
  let roles = {}
  // let obj = await this.$store.state.ioh.get_roles()
  // TODO Temporal
  let obj = {}
  obj.roles =  [
    {
      "rol": "administrador",
      "vistas": [
        "home",
        "tareas",
        "reasignacion",
        "usuarios",
        "reasignacion",
        "usuarios"
      ]
    },
    {
      "rol": "gerente",
      "vistas": [
        "home",
        "tareas",
        "estadisticas"
      ]
    },
    {
      "rol": "ejecutivo",
      "vistas": [
        "home",
        "tareas",
        "propiedades",
        "estadisticas"
      ]
    },
    {
      "rol": "developer",
      "vistas": [
        "home",
        "tareas",
        "propiedades",
        "load_file",
        "estadisticas",
        "reasignacion",
        "usuarios",
        "developer"
      ]
    },
    {
      "rol": "jefe",
      "vistas": [
        "home",
        "tareas",
        "propiedades",
        "load_file",
        "estadisticas",
        "reasignacion"
      ]
    },
    {
      "rol": "asistente",
      "vistas": [
        "home",
        "tareas",
        "propiedades",
        "load_file",
        "estadisticas"
      ]
    },
    {
      "rol": "levantador",
      "vistas": [
        "home",
        "tareas",
        "propiedades"
      ]
    }
  ]
  obj.status = 1
  // FIN TEMPORAL
  if (obj.status !== 1) {
  // if (obj.status !== this.$store.state.ioh.STATUS_OK) {
    // TODO  Temporal
    obj.reason = 'Error al obtener los roles desde la base.'
    console.error('getRoles:', obj.reason)
    return null
  }

  if (obj.roles === undefined || obj.roles === null){
    console.error('No se encuentran los roles en el objeto')
    return null
  }

  for(let idx = 0; idx < obj.roles.length; idx++){
    let rol = obj.roles[idx].rol
    let view = obj.roles[idx].vistas
    roles[rol] = view
  }
  return roles
}
